import {
 afterNextRender,
 afterRender,
 AfterViewInit,
 Component,
 DestroyRef,
 effect,
 ElementRef,
 EventEmitter,
 HostListener,
 inject,
 Inject,
 InjectionToken,
 Input,
 OnChanges,
 OnDestroy,
 OnInit,
 Output,
 PLATFORM_ID,
 signal,
 SimpleChanges,
 ViewChild,
 WritableSignal,
} from '@angular/core';
import { CommonModule, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { RouterModule, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LoginRegisterUiService } from '../../../pages/login-register/login-register-ui.service';
import {
 GetUserProfileResponse,
 LatestActiveReserveResponse,
} from '@core/models/DTOs/userProfile.dto';
import { UserProfileRepository } from '@core/services/repositories/userProfile.repository';
import { AuthService } from '@core/services/authentication/auth.service';
import { UtmService } from '@core/services/utm.service';
import { Subscription, filter, tap, distinctUntilChanged, fromEvent, take } from 'rxjs';
import { NotificationService } from '../notification/notification.service';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { LastReserveCardComponent } from '../last-reserve-card/last-reserve-card.component';
import { WebengageService } from '@core/services/webengage.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IHOBadgeModule, IHOBreadcrumbModule, IHOButtonModule, IHOCardModule, IHOFooterModule, IHOInputModule, IHONavbarModule, IHOTabModule } from 'design-system';

@Component({
 selector: 'iho-top-nav',
 standalone: true,
 templateUrl: './top-nav.component.html',
 styleUrls: ['./top-nav.component.scss'],
 imports: [
  CommonModule,
  MatRippleModule,
  RouterModule,
  MatMenuModule,
  MatDialogModule,
  NgOptimizedImage,
  LastReserveCardComponent,
  IHOBadgeModule,
 ],
})
export class TopNavComponent implements OnDestroy, OnChanges {
 drawerIsOpen = false;
 subscription: Subscription;
 showHeader =
  this.router.routerState.snapshot.url == '/' ||
  this.router.routerState.snapshot.url == '/ecolodge';
 navigatorVall: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(window.navigator.userAgent)
  : undefined;
 cdnUrl = cdnUrl;
 ssrStatus = signal(true);
 @Input() userDataTopNav!: GetUserProfileResponse;
 destroyRef = inject(DestroyRef);
 userData!: WritableSignal<any>;
 isScrollingDown = false;
 lastScrollY = 0;
 showTopNav = true;
 private menuCloseTimer?: ReturnType<typeof setTimeout>;
 constructor(
  public dialog: MatDialog,
  private route: ActivatedRoute,
  private router: Router,
  public notif: NotificationService,
  public UserProfileSrvc: UserProfileRepository,
  public AuthService: AuthService,
  public searchBoxService: SearchBoxService,
  public utmService: UtmService,
  public LoginRegisterUiService: LoginRegisterUiService,
  public webengageService: WebengageService,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {
  afterRender(() => {
   this.ssrStatus.set(false);
  });
  afterNextRender(() => {
   this.UserProfileSrvc.getLatestActiveReserve()
    .pipe(takeUntilDestroyed(this.destroyRef), take(1))
    .subscribe((data: any) => {
     const pageRoute = this.router.routerState.snapshot.url.split('/').length;
     this.latestActiveReserve = data.reserve;
     if (this.latestActiveReserve != null) {
      this.showCardWithData = true;
      this.webengageService.trackIntrack('show-last-reserve-modal', {
       pageName: pageRoute == 2 ? 'PHP' : pageRoute == 3 ? 'PLP' : 'PDP',
       status: data?.reserveStatusId == 112 ? 'waiting for hotel response' : 'payment',
       Platform: /Android|iPhone/.test(window.navigator.userAgent) ? 'mobile' : 'desktop',
       reserveId: data.reserveId,
      });
     }
    });
  });
  this.subscription = this.router.events
   .pipe(
    takeUntilDestroyed(this.destroyRef),
    filter((event) => event instanceof NavigationEnd)
   )
   .subscribe((event: any) => {
    // از این فلگ برای استیکی کردن هدر در صفحه هوم پیچ و همینطور نمایش دکمه پروفایل در سایر صفحات (موبایل) استفاده میکنیم
    if (event.url == '/' || event.url == '/ecolodge') this.showHeader = true;
    else this.showHeader = false;
   });
  effect(() => {
   this.userData = this.AuthService.getUserData();
  });
 }

 latestActiveReserve: LatestActiveReserveResponse = <LatestActiveReserveResponse>{};
 @Input() isLoading = true;
 @Output() toggleDrawer = new EventEmitter(this.drawerIsOpen);
 @ViewChild('hotelMenuTrigger') hotelMenu!: MatMenuTrigger;
 @ViewChild('ecolodgeMenuTrigger') ecolodgeMenu!: MatMenuTrigger;
 showCardReserve: boolean = false;
 showCardWithData = false;
 goToHome() {
  this.router.navigate(['/']);
 }
 ngOnChanges(changes: SimpleChanges): void {}

 openHotelMenu() {
  this.cancelMenuClose();
  this.ecolodgeMenu.closeMenu();
  this.hotelMenu.openMenu();
 }

 openEcolodgeMenu() {
  this.cancelMenuClose();
  this.hotelMenu.closeMenu();
  this.ecolodgeMenu.openMenu();
 }

 closeHotelMenu() {
  this.scheduleMenuClose(this.hotelMenu);
 }

 closeEcolodgeMenu() {
  this.scheduleMenuClose(this.ecolodgeMenu);
 }

 cancelMenuClose() {
  if (!isPlatformBrowser(this.platformId)) return;

  if (this.menuCloseTimer !== undefined) clearTimeout(this.menuCloseTimer);
  this.menuCloseTimer = undefined;
 }

 private scheduleMenuClose(trigger: MatMenuTrigger) {
  if (!isPlatformBrowser(this.platformId)) return;

  this.cancelMenuClose();
  // Allow the pointer to cross the gap between the trigger and the overlay.
  this.menuCloseTimer = setTimeout(() => {
   trigger.closeMenu();
   this.menuCloseTimer = undefined;
  }, 200);
 }

 toggleSideNav() {
  //this.drawerIsOpen = !this.drawerIsOpen
  this.toggleDrawer.emit(true);
 }

 logOut(e: any) {
  e.preventDefault();
  e.stopPropagation();
  this.AuthService.logOutUser()!
   .pipe(tap((_) => this.notif.success('خروج کاربر', '   با موفقیت انجام شد')))
   .subscribe(() => {
    this.router.navigate([], {
     queryParams: this.route.snapshot.queryParams,
     relativeTo: this.route,
    });
   });
 }
 ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
    this.lastScrollY = window.scrollY;
  }
 }
 openDialog() {
  this.LoginRegisterUiService.showMyModal();
 }
 ngOnDestroy(): void {
  this.cancelMenuClose();
  this.subscription.unsubscribe();
 }
 resetRayaChat(ev:Event) {
  if (this.navigatorVall) {
   const rayachatNode = document.getElementById('raychat_widget') as HTMLElement;
   if (rayachatNode) rayachatNode.style.bottom = '60px';
   if (rayachatNode) rayachatNode.style.transition = '0.3s ease-in-out all';
  }
 }
 emitClose(ev: boolean) {
  this.showCardReserve = ev;
 }
}
